import { MdEmail } from 'react-icons/md';
import * as React from 'react';
export default {
  MdEmail,
  React
};